<!-- start blog -->
<section class="section" id="blog">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="text-center mb-5">
                    <h1 class="mb-3 ff-secondary fw-semibold text-capitalize lh-base">Our Latest <span
                            class="text-primary">News</span></h1>
                    <p class="text-muted mb-4">We thrive when coming up with innovative ideas but also understand that a
                        smart concept should be supported with faucibus sapien odio measurable results.</p>
                </div>
            </div>
        </div>
        <!-- end row -->

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <img src="assets/images/small/img-8.jpg" alt="" class="img-fluid rounded" />
                    </div>
                    <div class="card-body">
                        <ul class="list-inline fs-14 text-muted">
                            <li class="list-inline-item">
                                <i class="ri-calendar-line align-bottom me-1"></i> 30 Oct, 2021
                            </li>
                            <li class="list-inline-item">
                                <i class="ri-message-2-line align-bottom me-1"></i> 364 Comment
                            </li>
                        </ul>
                        <a href="javascript:void(0);">
                            <h5>Design your apps in your own way ?</h5>
                        </a>
                        <p class="text-muted fs-14">One disadvantage of Lorum Ipsum is that in Latin certain letters
                            appear more frequently than others.</p>

                        <div>
                            <a href="#!" class="link-secondary">Learn More <i
                                    class="ri-arrow-right-line align-bottom ms-1"></i></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <img src="assets/images/small/img-6.jpg" alt="" class="img-fluid rounded" />
                    </div>
                    <div class="card-body">
                        <ul class="list-inline fs-14 text-muted">
                            <li class="list-inline-item">
                                <i class="ri-calendar-line align-bottom me-1"></i> 02 Oct, 2021
                            </li>
                            <li class="list-inline-item">
                                <i class="ri-message-2-line align-bottom me-1"></i> 245 Comment
                            </li>
                        </ul>
                        <a href="javascript:void(0);">
                            <h5>Smartest Applications for Business ?</h5>
                        </a>
                        <p class="text-muted fs-14">Due to its widespread use as filler text for layouts,
                            non-readability is of great importance: human perception.</p>

                        <div>
                            <a href="#!" class="link-secondary">Learn More <i
                                    class="ri-arrow-right-line align-bottom ms-1"></i></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <img src="assets/images/small/img-9.jpg" alt="" class="img-fluid rounded" />
                    </div>
                    <div class="card-body">
                        <ul class="list-inline fs-14 text-muted">
                            <li class="list-inline-item">
                                <i class="ri-calendar-line align-bottom me-1"></i> 23 Sept, 2021
                            </li>
                            <li class="list-inline-item">
                                <i class="ri-message-2-line align-bottom me-1"></i> 354 Comment
                            </li>
                        </ul>
                        <a href="javascript:void(0);">
                            <h5>How apps is changing the IT world</h5>
                        </a>
                        <p class="text-muted fs-14">Intrinsically incubate intuitive opportunities and real-time
                            potentialities Appropriately communicate one-to-one technology.</p>

                        <div>
                            <a href="#!" class="link-secondary">Learn More <i
                                    class="ri-arrow-right-line align-bottom ms-1"></i></a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <!-- end container -->
</section>
<!-- end blog -->

<!-- start cta -->
<section class="py-5 bg-primary position-relative">
    <div class="bg-overlay bg-overlay-pattern opacity-50"></div>
    <div class="container">
        <div class="row align-items-center gy-4">
            <div class="col-sm">
                <div>
                    <h4 class="text-white fw-semibold">Get New Jobs Notification!</h4>
                    <p class="text-white text-opacity-75 mb-0">Subscribe & get all related jobs notification.</p>
                </div>
            </div>
            <!-- end col -->
            <div class="col-sm-auto">
                <button class="btn btn-secondary" type="button">Subscribe Now <i
                        class="ri-arrow-right-line align-bottom"></i></button>
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </div>
    <!-- end container -->
</section>
<!-- end cta -->